$(window).on('resize', function(e){
  var width = $(window).width();
  width = parseInt(width, 10);

  // //set banner padding to match nav edges
  // if (width > 767) {
  //   $('.banner').css('padding-left',$('#nav-browse').offset().left);
  //   $('.banner').css('padding-right',$(window).width() - ($('#nav-cart').offset().left + $('#nav-cart').width()));
  // }
  // else {
  //   $('.banner').css('padding-left', 10);
  //   $('.banner').css('padding-right', 10);
  // }


  //log bootstrap breakpoints to console; use for debugging
  if (width >= 1200) {
    console.log('bs grid size:  lg');
  }
  else if (width >= 992 && width < 1200) {
    console.log('bs grid size:  md');
  }
  else if (width >= 768 && width < 992) {
    if ($('#login_vert_line').length === 0) {
      $('<div id="login_vert_line" class="col-md-1 col-md-offset-1 col-sm-1 col-sm-offset-1" style="border-left: thin solid #aaaaaa;height:440px"></div>').insertAfter('#login_box');
    }
    console.log('bs grid size:  sm');
  }
  else {
    if ($('#login_vert_line').length > 0) {
      $('#login_vert_line').remove();
    }
    console.log('bs grid size:  xs');
  }

  //banner logo resize
  if (width < 620) {
    $('.banner-logo').attr('src','//cdn.shopify.com/s/files/1/0562/7365/t/5/assets/pomu_logo_abbr.png?570');
  }
  else if (width >= 620) {
    $('.banner-logo').attr('src','//cdn.shopify.com/s/files/1/0598/2925/t/3/assets/pomu_logo_full.png?11745');
  }
});

$(document).ready(function(){
  var width = $(window).width();
  width = parseInt(width, 10);

  // //set banner padding to match nav edges
  // if (width > 767) {
  //   $('.banner').css('padding-left',$('#nav-browse').offset().left);
  //   $('.banner').css('padding-right',$(window).width() - ($('#nav-cart').offset().left + $('#nav-cart').width()));
  // }
  // else {
  //   $('.banner').css('padding-left', 10);
  //   $('.banner').css('padding-right', 10);
  // }

  //banner logo resize
  if (width < 620) {
    $('.banner-logo').attr('src','//cdn.shopify.com/s/files/1/0562/7365/t/5/assets/pomu_logo_abbr.png?570');
  }
  else if (width >= 620) {
    $('.banner-logo').attr('src','//cdn.shopify.com/s/files/1/0598/2925/t/3/assets/pomu_logo_full.png?11745');
  }

  //url parser to determine current collection and applied tags
  var parser = document.createElement('a');
  parser.href = document.URL;
  var path = parser.pathname;

  if (path.indexOf('collections') >= 0) {
    tmp = path.substring(path.indexOf('collections/')+12, path.length);

    var end = tmp.indexOf('/') >= 0 ? tmp.indexOf('/') : tmp.length;
    var coll = tmp.substring(0, end);
    var tags = tmp.substring(tmp.indexOf(coll+'/')+coll.length+1).split('+');
    tags = tmp.split('+');

    $('#tag_'+coll).addClass('selected');
  }

  //filter buttons
  var arr = ['category','price','size'];
  for (var i=0; i < arr.length; i++) {
    (function(num){
      $('#'+arr[num]).on('click', function(){

        //toggle +/-
        var tmp = $(this).html();
        if (tmp.indexOf('plus') > 0) {
          tmp = tmp.replace('plus','minus');
        }
        else {
          tmp = tmp.replace('minus','plus');
        }
        $(this).html(tmp);

        //expand/collapse group items
        $('#filter-group-'+arr[num]).toggle();
      });
    })(i);
  }

  //open filter lists when item(s) selected
  var all = path.indexOf('/all') + 4;
  if (all !== path.length) {
    $('#category').click();
  }

  var prices = 'under-50;50-100;100-250;250-500;500-1000;1000-2500;2500-5000;over-5000';
  prices = prices.split(';');
  for (var p=0; p < prices.length; p++) {
    if (path.indexOf(p) > 0) {
      $('#price').click();
      break;
    }
  }

  var sizes = 'small;medium;large;oversized';
  sizes = sizes.split(';');
  for (var s=0; s < sizes.length; s++ ) {
    if (path.indexOf(sizes[s]) > 0) {
      $('#size').click();
      break;
    }
  }

});
